// frontend/src/components/shared/VerifiedBadge.jsx
import React from 'react';
import { BadgeCheck } from 'lucide-react';

/**
 * Verified creator badge. Renders nothing when `verified` is falsy.
 * size: "sm" | "md"
 */
const VerifiedBadge = ({ verified, size = 'sm', showLabel = false, className = '' }) => {
  if (!verified) return null;
  const dim = size === 'md' ? 'w-5 h-5' : 'w-4 h-4';
  return (
    <span className={`inline-flex items-center gap-1 text-blue-600 ${className}`} title="Verified creator">
      <BadgeCheck className={dim} aria-label="Verified creator" />
      {showLabel && <span className="text-xs font-semibold">Verified</span>}
    </span>
  );
};

export default VerifiedBadge;
